<template>
  <div class="container-fluid bg-success">
    <nav class="navbar navbar-expand-xl navbar-dark bg-success text-light">
      <div class="container-lg">
        <!-- navbar brand / title -->
        <span class="fw-bold">
          <a href="#" class="text-light text-decoration-none">
            <span v-if="this.GStore.currentUser">
              {{ "Hello " + this.GStore.currentUser.email }}
            </span>
          </a>
        </span>

        <!-- toggle button for mobile nav -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#main-nav"
          aria-controls="main-nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- navbar links -->
        <div
          class="
            collapse
            navbar-collapse
            justify-content-start
            align-center
            text-light
          "
          id="main-nav"
          
        >
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link class="nav-link" to="/">
                Home
              </router-link>
            </li>
            <li v-if="this.GStore.currentUser" class="nav-item">
              <router-link class="nav-link" :to="{ name: 'Thoughts' }">
                Thoughts
              </router-link>
            </li>
          
            <li class="nav-item">
              <span v-if="this.GStore.currentUser" class="nav-link" style="cursor:pointer" @click="logOut">Log Out</span>
              <router-link v-else class="nav-link" :to="{ name: 'LogIn' }">
                Login
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <div class="container-lg py-3">
    <router-view />
  </div>

  <div class="container-fluid bg-success text-white">
    <div class="container-lg">
      <footer class="fs-6 py-2">&copy; 2023 NK</footer>
    </div>
  </div>
</template>
<script>
import { signOut, auth, onAuthStateChanged} from "./firebaseApp";
//import bootstrap from 'bootstrap'
//import Collapse from 'bootstrap/js/dist/collapse'

export default {
  inject: ["GStore"],
  methods: {
    logOut(evt) {
      evt.preventDefault();
      this.signOutOfFirebase();
    },
    signOutOfFirebase() {
      //sessionStorage.removeItem("currentUser");
      signOut(auth).then(() => {
        this.GStore.currentUser = null;
        //console.log("GStroe curentUser",this.GStore.currentUser);
        this.$router.push({ name: "Home" });
      });
    },
  },
  mounted() {

    /*
    const navLinks = document.querySelectorAll('.nav-item')
    const menuToggle = document.getElementById('main-nav')
    const bsCollapse = new Collapse(menuToggle)
    navLinks.forEach((l) => {
        l.addEventListener('click', () => { bsCollapse.toggle() })
    })
    */

    // If the user is already logged into FB, we need to set the currentUser
    onAuthStateChanged(auth, user => {
        //console.log("AuthStateChange (in App)")
        if(user){
            this.GStore.currentUser = {id:user.uid, email:user.email}
        }
    })
    
  },
};
</script>

<style>
</style>
